import { Subject } from 'rxjs';

import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnLocation } from '@lib/api/entities';
import { GoogleMapStyle } from '@lib/geo/google/map';
import { FsMap } from '@lib/geo/map';

import { AppliancesMapService } from '../../services/appliances-map.service';
import { ApplianceMapMaximizerDialogComponent } from '../appliance-map-maximizer-dialog/appliance-map-maximizer-dialog.component';

@Component({
  selector: 'fs-appliance-dashboard-location-map',
  templateUrl: './appliance-dashboard-location-map.component.html',
  styleUrls: ['./appliance-dashboard-location-map.component.scss'],
})
export class ApplianceDashboardLocationMapComponent implements OnDestroy {
  @Input() public location: SnLocation;

  @Output()
  public readonly editAppliance = new EventEmitter<void>();

  private map: FsMap;
  private readonly _destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog, private mapUtility: AppliancesMapService) {}

  public onMapInit(map: FsMap): void {
    this.map = map;

    if (this.location?.geometry?.coordinates) {
      this.mapUtility.setupMap(
        map,
        GoogleMapStyle.Satellite,
        this.location.geometry.coordinates,
        18,
      );
      this.mapUtility.createMarker(map, this.location.geometry.coordinates);
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public openMaximizedMap(): void {
    if (!this.location?.geometry?.coordinates) {
      return;
    }

    this.dialog.open(ApplianceMapMaximizerDialogComponent, {
      data: {
        coordinates: this.location.geometry.coordinates,
        style: this.map.getStyle(),
        zoom: this.map.getZoom(),
        address: this.location.fullAddress,
      },
      width: '80vw',
      height: '80vh',
      maxHeight: '80vh',
      panelClass: 'map-maximizer-dialog',
    });
  }

  public onEditAppliance(): void {
    this.editAppliance.emit();
  }
}
